import { insertLinks } from './utils';
export const resolveAbilities = (uidl, options) => {
    uidl.node = insertLinks(uidl.node, options);
};
//# sourceMappingURL=index.js.map